import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';

type SidePanelHeaderProps = {
	children: React.ReactNode;
};

export const SidePanelHeader = ({ children }: SidePanelHeaderProps): React.JSX.Element => {
	return (
		<Box paddingBlock="space.100" paddingInlineStart="space.300" paddingInlineEnd="space.150">
			{children}
		</Box>
	);
};
